import {
  CapacitorUpdater,
  type DownloadCompleteEvent,
} from '@capgo/capacitor-updater';
import { useEffect } from 'react';

import { getPlatform } from '@/shared/utils/platform';

export function useOnOtaUpdateDownloaded(
  listener: (event: DownloadCompleteEvent) => void,
) {
  useEffect(() => {
    if (getPlatform() === 'WEB') return;

    const listenerPromise = CapacitorUpdater.addListener(
      'downloadComplete',
      listener,
    );
    return () => {
      void listenerPromise.then(listener => listener.remove());
    };
  }, [listener]);
}
